/* eslint-disable */
export default {
  toolTip: 'Visualizar no {crmName}',
} as const;

// @key: @#@"toolTip"@#@ @source: @#@"View in {crmName}"@#@
